import React from "react";

const InfoPage = ({ question, value, onChange }) => {
  const { questionId, label, title, content, acknowledgmentLabel } = question;

  // Info pages can optionally have an acknowledgment checkbox
  const requiresAck = question.required;
  const displayContent = content || label;
  const ackLabel = acknowledgmentLabel || "I have read and understood the above information";

  return (
    <div>
      {title && (
        <h3 className="text-base font-semibold text-spiders-text-primary mb-3">
          {title}
        </h3>
      )}
      <div className="prose prose-sm prose-invert max-w-none text-spiders-text-secondary leading-relaxed whitespace-pre-line">
        {displayContent}
      </div>
      {requiresAck && (
        <label className="flex items-start gap-3 mt-6 cursor-pointer">
          <input
            type="checkbox"
            checked={value === true}
            onChange={(e) => onChange(questionId, e.target.checked)}
            className="mt-0.5 w-4 h-4 rounded border-spiders-border accent-spiders-primary-500"
          />
          <span className="text-sm text-spiders-text-secondary">
            {ackLabel}
          </span>
        </label>
      )}
    </div>
  );
};

export default InfoPage;
